'use client';

import { useSessionContext } from '@users/session/SessionContext';
import SentryUserData from '@framework/sentry/SentryUserData';

interface IProps {
  children: React.ReactNode,
}

const SentryUserDataWrapper = ({ children }: IProps) => {
  const { currentUser } = useSessionContext();

  return (
    <SentryUserData user={ currentUser }>
      { children }
    </SentryUserData>
  );
};

export default SentryUserDataWrapper;
